

// Definicion completa de la barra superior.
//
// `hidden: true` oculta la entrada SIN borrarla: el modulo sigue existiendo
// (ruta, vista y permisos intactos) y solo desaparece del menu. Para volver a
// mostrarlo basta con quitar esa linea.
const menuItemsAll = [


  {
    id: 2,
    label: "Inicio",
    icon: " ri-dashboard-line",
    link: "/"


  },
  {
    id: 8,
    label: "Gestión empresa",
    icon: " ri-file-user-line",
    link: "/forms/listado-empresa"


  },
  {
    id: 19,
    label: 'Estándares',
    icon: 'ri-checkbox-line',
    link: '/forms/estandares'
  },
  /*{
    id: 19,
    label: 'Reportes',
    icon: ' ri-file-edit-fill',
    link: '/'
  },
  {
    id: 20,
    label: 'Configuraciones',
    icon: 'ri-settings-4-fill',
    link: '/'
  },*/
  {
    id: 21,
    label: 'Notificaciones',
    icon: ' ri-chat-3-fill',
    link: '/forms/notifications-list'
  },
  {
    id: 26,
    label: 'Reporte',
    icon: 'ri-settings-4-fill',
    link: '/forms/reporte',
    // Oculto temporalmente: el modulo esta roto/desactualizado y entra en la
    // proxima entrega. Quitar esta linea para volver a mostrarlo.
    hidden: true
  },
  /* {
     id: 22,
     label: 'Mensajes',
     icon: 'ri-message-line',
     link: '/'
   },*/
  {
    id: 22,
    label: 'Base de conocimiento',
    icon: ' ri-bookmark-fill',
    link: '/forms/general'
  },
  {
    id: 23,
    label: 'Usuarios',
    icon: 'ri-file-user-fill',
    link: '/forms/users'
  },

/*   {
    id: 20,
    label: 'Configuraciones',
    icon: 'ri-settings-4-fill',
    link: '/forms/configuracion'
  }, */
  {
    id: 24,
    label: 'PHVA',
    icon: 'ri-settings-4-fill',
    link: '/forms/phva'
  },
  {
    id: 25,
    label: 'Manual de usuario',
    icon: 'ri-file-fill',
    link: '/forms/manualUsuario',
    // Oculto temporalmente: el contenido esta desactualizado y entra en la
    // proxima entrega. Quitar esta linea para volver a mostrarlo.
    hidden: true
  },

];

export const menuItems = menuItemsAll.filter((item) => !item.hidden);

// ── Presentación del riel lateral (AppShell) ─────────────────────────────────
// Solo agrupa y re-iconiza las MISMAS entradas de `menuItems` (por `link`);
// no cambia rutas, `hidden` ni filtros de rol (esos viven en AppShell.vue y
// replican `knowUserRole()` de Horizontal-navbar.vue).
export const menuGroups = [
  {
    id: "cumplimiento",
    label: "Cumplimiento",
    links: ["/", "/forms/estandares", "/forms/phva", "/forms/reporte"],
  },
  {
    id: "gestion",
    label: "Gestión",
    links: ["/forms/listado-empresa", "/forms/users", "/forms/notifications-list"],
  },
  {
    id: "conocimiento",
    label: "Conocimiento",
    links: ["/forms/general", "/forms/manualUsuario"],
  },
];

// Iconos Remix de contorno (coherentes entre sí; sin rellenos ni repetidos).
export const menuIcons = {
  "/": "ri-dashboard-line",
  "/forms/estandares": "ri-checkbox-line",
  "/forms/phva": "ri-refresh-line",
  "/forms/reporte": "ri-bar-chart-2-line",
  "/forms/listado-empresa": "ri-building-line",
  "/forms/users": "ri-group-line",
  "/forms/notifications-list": "ri-notification-3-line",
  "/forms/general": "ri-book-open-line",
  "/forms/manualUsuario": "ri-book-2-line",
};
